export default class Validator {
    static checkPasswordRestrictions(event) {
        const password = event.target.value;
        let valid = this.isValidLength(password);
        let element = document.querySelector('#minCharacters');
        this.setRestrictionClass(valid, element);
        valid = this.hasNumberAndSpecialCharacter(password);
        element = document.querySelector('#lettersAndNumbers');
        this.setRestrictionClass(valid, element);
        const regFormEmail = document.querySelector('#regFormEmail');
        const email = regFormEmail.value;
        valid = this.isDifferentFromEmail(password, email);
        element = document.querySelector('#partOfEmail');
        this.setRestrictionClass(valid, element);
        element = document.querySelector('#passwordRestrictionInfo');
        valid = this.isValidPassword();
        this.setRestrictionClass(valid, element);
    }
    static hasNumberAndSpecialCharacter(regFormPassword) {
        return (/.*[a-zA-Z]+.*/g.test(regFormPassword) &&
            (/.*[0-9]+.*/g.test(regFormPassword) ||
                /.*[^a-zA-Z0-9\s]+.*/g.test(regFormPassword)));
    }
    static isDifferentFromEmail(regFormPassword, regFormEmail) {
        return regFormPassword !== regFormEmail;
    }
    static isValidEmail() {
        const regFormEmail = document.querySelector(' #regFormEmail');
        const regExp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g;
        const isValidEmail = regExp.test(regFormEmail.value);
        return regFormEmail.value !== "" && isValidEmail;
    }
    ;
    static isValidGender() {
        return ((document.querySelector('input[name="mysex"]:checked')) &&
            document.querySelector('[name="essex"]').value !== '');
    }
    ;
    static isValidLength(string) {
        return string.length >= this.minimumPasswordLength;
    }
    static isPasswordEmpty() {
        const regFormPassword = document.querySelector(' #regFormPassword');
        const password = regFormPassword.value;
        return password === '';
    }
    ;
    static isValidPassword() {
        const regFormPassword = document.querySelector(' #regFormPassword');
        const regFormEmail = document.querySelector(' #regFormEmail');
        const password = regFormPassword.value;
        const email = regFormEmail.value;
        const hasMinimum8chars = this.isValidLength(password);
        const isDifferentFromEmail = this.isDifferentFromEmail(password, email);
        const hasNumberAndSpecialCharacter = this.hasNumberAndSpecialCharacter(password);
        return hasMinimum8chars && isDifferentFromEmail && hasNumberAndSpecialCharacter;
    }
    ;
    static setRestrictionClass(successful, element) {
        if (successful) {
            element.classList.add('success');
            element.classList.remove('error');
        }
        else {
            element.classList.add('error');
            element.classList.remove('success');
        }
    }
}
Validator.minimumPasswordLength = 8;
